import React from 'react';
import InlineAlert from '../../../shared/components/InlineAlert';
import type { useAccountSectionSave } from '../hooks/useAccountSectionSave';

/** What the tab's last save did, shown beside its Save. */
const SectionSaveOutcome: React.FC<{ section: ReturnType<typeof useAccountSectionSave> }> = ({ section }) => (
  <>
    {section.error && (
      <InlineAlert severity="error" onClose={section.clearError}>
        Could not save: {section.error}
      </InlineAlert>
    )}
    {section.saved && <InlineAlert severity="success">Saved</InlineAlert>}
  </>
);

export default SectionSaveOutcome;
